import cx from 'classnames';
import React, {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';

import {Dialog, DialogContent, DialogActions, Button, DialogMaxWidth, IconName, DialogMinWidth} from 'components/UIKit';
import {TRANSLATION_KEYS} from 'locale/translation-keys';

const T_KEYS = TRANSLATION_KEYS.COMMON.BUTTONS;

type Props = {
    open: boolean,
    title?: string | React.ReactElement,
    content?: string,
    children?: ReactNode,
    className?: string;
    data?: any,
    okText?: string;
    okDisabled?: boolean;
    cancelText?: string;
    maxWidth?: DialogMaxWidth;
    minWidth?: DialogMinWidth;
    fullWidth?: boolean;
    fullScreen?: boolean;
    cancelBtnColor?: 'default' | 'primary' | 'attention';
    cancelBtnClassName?: string;
    okBtnColor?: 'default' | 'primary' | 'attention';
    contentClassName?: string;
    hideCancelButton?: boolean;
    titleIcon?: IconName;
    closeTimeoutMS?: number;
    onTitleIconClick?: () => void;
    onFullScreenChange?: () => void;
    onClose: (confirm: boolean, data?: any) => void;
};

export const ConfirmModal: React.FC<Props> = ({
    children, open, className, title, content, data, maxWidth, minWidth, fullWidth, fullScreen, contentClassName, closeTimeoutMS,
    onClose, okText, cancelText, cancelBtnColor, cancelBtnClassName, okBtnColor, okDisabled, hideCancelButton, titleIcon, onTitleIconClick,
    onFullScreenChange
}) => {
    const {t} = useTranslation();

    return (
        <Dialog
            className={className}
            title={title}
            open={open}
            maxWidth={maxWidth}
            minWidth={minWidth}
            fullWidth={fullWidth}
            fullScreen={fullScreen}
            closeTimeoutMS={closeTimeoutMS}
            titleIcon={onFullScreenChange ? (fullScreen ? 'shrink' : 'expand') : titleIcon}
            onTitleIconClick={onFullScreenChange ? onFullScreenChange : onTitleIconClick}
        >

            {(content || children) && <DialogContent className={contentClassName}>{content || children}</DialogContent>}

            <DialogActions>
                {!hideCancelButton &&
                    <Button
                        width='small'
                        className={cx('tw-ml-3', cancelBtnClassName)}
                        color={cancelBtnColor || 'default'}
                        onClick={() => onClose(false, data)}
                    >
                        {cancelText || t(T_KEYS.CANCEL)}
                    </Button>}
                <Button
                    className='tw-ml-3'
                    color={okBtnColor || 'primary'}
                    disabled={okDisabled}
                    width='small'
                    onClick={() => onClose(true, data)}
                >
                    {okText || t(T_KEYS.OK)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export type ConfirmModalProps = Props;